// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseRolloutState } from './ResponseRolloutState';
import {
  ResponseRolloutStateFromJSON,
  ResponseRolloutStateFromJSONTyped,
  ResponseRolloutStateToJSON,
  ResponseRolloutStateToJSONTyped,
} from './ResponseRolloutState';
import type { ResponsePropagation } from './ResponsePropagation';
import {
  ResponsePropagationFromJSON,
  ResponsePropagationFromJSONTyped,
  ResponsePropagationToJSON,
  ResponsePropagationToJSONTyped,
} from './ResponsePropagation';
import type { ResponseSkippedResourcesForKind } from './ResponseSkippedResourcesForKind';
import {
  ResponseSkippedResourcesForKindFromJSON,
  ResponseSkippedResourcesForKindFromJSONTyped,
  ResponseSkippedResourcesForKindToJSON,
  ResponseSkippedResourcesForKindToJSONTyped,
} from './ResponseSkippedResourcesForKind';
import type { ResponseResourceProgress } from './ResponseResourceProgress';
import {
  ResponseResourceProgressFromJSON,
  ResponseResourceProgressFromJSONTyped,
  ResponseResourceProgressToJSON,
  ResponseResourceProgressToJSONTyped,
} from './ResponseResourceProgress';
import type { ResponseClusterStepDetail } from './ResponseClusterStepDetail';
import {
  ResponseClusterStepDetailFromJSON,
  ResponseClusterStepDetailFromJSONTyped,
  ResponseClusterStepDetailToJSON,
  ResponseClusterStepDetailToJSONTyped,
} from './ResponseClusterStepDetail';
import type { ResponseClusterCompletionStepDetail } from './ResponseClusterCompletionStepDetail';
import {
  ResponseClusterCompletionStepDetailFromJSON,
  ResponseClusterCompletionStepDetailFromJSONTyped,
  ResponseClusterCompletionStepDetailToJSON,
  ResponseClusterCompletionStepDetailToJSONTyped,
} from './ResponseClusterCompletionStepDetail';
import type { ResponseCondition } from './ResponseCondition';
import {
  ResponseConditionFromJSON,
  ResponseConditionFromJSONTyped,
  ResponseConditionToJSON,
  ResponseConditionToJSONTyped,
} from './ResponseCondition';
import type { ResponseClusterRolloutAction } from './ResponseClusterRolloutAction';
import {
  ResponseClusterRolloutActionFromJSON,
  ResponseClusterRolloutActionFromJSONTyped,
  ResponseClusterRolloutActionToJSON,
  ResponseClusterRolloutActionToJSONTyped,
} from './ResponseClusterRolloutAction';

/**
 *
 * @export
 * @interface ResponseClusterRollout
 */
export interface ResponseClusterRollout {
  /**
   * Actions are the user actions recorded for this rollout, oldest first,
   * with whether this cluster applied them.
   * @type {Array<ResponseClusterRolloutAction>}
   * @memberof ResponseClusterRollout
   */
  actions?: Array<ResponseClusterRolloutAction>;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRollout
   */
  clusterName?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRollout
   */
  completedAt?: string;
  /**
   *
   * @type {ResponseClusterCompletionStepDetail}
   * @memberof ResponseClusterRollout
   */
  completionStep?: ResponseClusterCompletionStepDetail;
  /**
   *
   * @type {Array<ResponseCondition>}
   * @memberof ResponseClusterRollout
   */
  conditions?: Array<ResponseCondition>;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRollout
   */
  identifier?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRollout
   */
  operatorName?: string;
  /**
   * Propagation is omitted when no action has been propagated to the
   * cluster yet, i.e. it has no propagation state.
   * @type {ResponsePropagation}
   * @memberof ResponseClusterRollout
   */
  propagation?: ResponsePropagation;
  /**
   *
   * @type {Array<ResponseResourceProgress>}
   * @memberof ResponseClusterRollout
   */
  resourceProgresses?: Array<ResponseResourceProgress>;
  /**
   *
   * @type {Array<ResponseSkippedResourcesForKind>}
   * @memberof ResponseClusterRollout
   */
  skippedResources?: Array<ResponseSkippedResourcesForKind>;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRollout
   */
  startedAt?: string;
  /**
   * State is what the cluster is currently told to do, as opposed to the
   * Paused and Aborted conditions, which report what has happened.
   * @type {ResponseRolloutState}
   * @memberof ResponseClusterRollout
   */
  state?: ResponseRolloutState;
  /**
   *
   * @type {Array<ResponseClusterStepDetail>}
   * @memberof ResponseClusterRollout
   */
  steps?: Array<ResponseClusterStepDetail>;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRollout
   */
  transferFinishedAt?: string;
}

/**
 * Check if a given object implements the ResponseClusterRollout interface.
 */
export function instanceOfResponseClusterRollout(
  value: object,
): value is ResponseClusterRollout {
  return true;
}

export function ResponseClusterRolloutFromJSON(
  json: any,
): ResponseClusterRollout {
  return ResponseClusterRolloutFromJSONTyped(json, false);
}

export function ResponseClusterRolloutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseClusterRollout {
  if (json == null) {
    return json;
  }
  return {
    actions:
      json['actions'] == null
        ? undefined
        : (json['actions'] as Array<any>).map(
            ResponseClusterRolloutActionFromJSON,
          ),
    clusterName: json['clusterName'] == null ? undefined : json['clusterName'],
    completedAt: json['completedAt'] == null ? undefined : json['completedAt'],
    completionStep:
      json['completionStep'] == null
        ? undefined
        : ResponseClusterCompletionStepDetailFromJSON(json['completionStep']),
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ResponseConditionFromJSON),
    identifier: json['identifier'] == null ? undefined : json['identifier'],
    operatorName:
      json['operatorName'] == null ? undefined : json['operatorName'],
    propagation:
      json['propagation'] == null
        ? undefined
        : ResponsePropagationFromJSON(json['propagation']),
    resourceProgresses:
      json['resourceProgresses'] == null
        ? undefined
        : (json['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressFromJSON,
          ),
    skippedResources:
      json['skippedResources'] == null
        ? undefined
        : (json['skippedResources'] as Array<any>).map(
            ResponseSkippedResourcesForKindFromJSON,
          ),
    startedAt: json['startedAt'] == null ? undefined : json['startedAt'],
    state:
      json['state'] == null
        ? undefined
        : ResponseRolloutStateFromJSON(json['state']),
    steps:
      json['steps'] == null
        ? undefined
        : (json['steps'] as Array<any>).map(ResponseClusterStepDetailFromJSON),
    transferFinishedAt:
      json['transferFinishedAt'] == null
        ? undefined
        : json['transferFinishedAt'],
  };
}

export function ResponseClusterRolloutToJSON(
  json: any,
): ResponseClusterRollout {
  return ResponseClusterRolloutToJSONTyped(json, false);
}

export function ResponseClusterRolloutToJSONTyped(
  value?: ResponseClusterRollout | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    actions:
      value['actions'] == null
        ? undefined
        : (value['actions'] as Array<any>).map(
            ResponseClusterRolloutActionToJSON,
          ),
    clusterName: value['clusterName'],
    completedAt: value['completedAt'],
    completionStep: ResponseClusterCompletionStepDetailToJSON(
      value['completionStep'],
    ),
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ResponseConditionToJSON),
    identifier: value['identifier'],
    operatorName: value['operatorName'],
    propagation: ResponsePropagationToJSON(value['propagation']),
    resourceProgresses:
      value['resourceProgresses'] == null
        ? undefined
        : (value['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressToJSON,
          ),
    skippedResources:
      value['skippedResources'] == null
        ? undefined
        : (value['skippedResources'] as Array<any>).map(
            ResponseSkippedResourcesForKindToJSON,
          ),
    startedAt: value['startedAt'],
    state: ResponseRolloutStateToJSON(value['state']),
    steps:
      value['steps'] == null
        ? undefined
        : (value['steps'] as Array<any>).map(ResponseClusterStepDetailToJSON),
    transferFinishedAt: value['transferFinishedAt'],
  };
}
